import { Controller } from "@hotwired/stimulus"

// The support chat, on both sides (support/show and admin/support/show).
// Keeps the newest message in view: on open, after sending, and when a message
// streams in. A message streaming in while the thread is on screen counts as
// read, so it posts seenUrl and the other side's "seen" updates live. Also
// keeps the user's send button greyed until there is something to send.
export default class extends Controller {
  static targets = ["list", "send"]
  static values = { seenUrl: String }

  connect() {
    this._observer = new MutationObserver(() => {
      this.scrollToEnd()
      this._markSeen()
    })
    this._observer.observe(this.listTarget, { childList: true })
    // A reply that streamed in while the phone was locked is read once the
    // open chat is back on screen.
    this._onVisible = () => this._markSeen()
    document.addEventListener("visibilitychange", this._onVisible)
    this.scrollToEnd()
  }

  disconnect() {
    this._observer.disconnect()
    document.removeEventListener("visibilitychange", this._onVisible)
  }

  toggleSend(event) {
    if (this.hasSendTarget) this.sendTarget.disabled = event.target.value.trim() === ""
  }

  scrollToEnd() {
    requestAnimationFrame(() => window.scrollTo(0, document.documentElement.scrollHeight))
  }

  // Same fire-and-forget POST as help_intro_controller. Skipped while the app
  // is in the background: a message nobody is looking at is not read.
  _markSeen() {
    if (!this.hasSeenUrlValue || document.visibilityState !== "visible") return
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.seenUrlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: { "X-CSRF-Token": token, Accept: "application/json" }
    }).catch(() => {})
  }
}
